import FactureView from "@features/achats/components/factures/FactureView";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { Receipt } from "lucide-react";

function FactureFournisseurViewPage() {
  const { id } = useParams({ from: Route.id });
  return <FactureView factureId={id} />;
}

export const Route = createFileRoute("/_app/comptabilite/factures-fournisseurs/$id/view")({
  staticData: {
    title: "Détails Facture Fournisseur",
    icon: Receipt,
    showInBreadcrumb: true,
  },
  component: FactureFournisseurViewPage,
});
